import { emptyCondition } from './criteriaUtils';

export function stampRuleNode(
  node,
  { offer_feature, offer_value, offer_value_label, label, direction }
) {
  if (!node || typeof node !== 'object') return node;
  const out = { ...node };
  out.offer_feature = offer_feature;
  out.offer_value = offer_value;
  if (offer_value_label != null) out.offer_value_label = offer_value_label;
  out.offer_direction = direction;
  if (out.kind === 'group') {
    if (label) out.display_name = label;
    out.children = (out.children || []).map((child) =>
      stampRuleNode(child, {
        offer_feature,
        offer_value,
        offer_value_label,
        label: null,
        direction,
      })
    );
  } else if (label && !out.display_name) {
    out.display_name = label;
  }
  return out;
}

export function parseStoredRule(raw) {
  if (!raw) return null;
  if (typeof raw === 'object') return raw;
  if (typeof raw !== 'string') return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

/** Include/exclude criteria node from a value-rules payload. Exclude is stored, not negated. */
export function nodeFromValueRule(row, { exclude = false } = {}) {
  const feature = String(row?.feature || '').trim();
  const value = String(row?.top_conv_value ?? row?.value ?? '').trim();
  const raw = parseStoredRule(exclude ? row?.exclude_rule : row?.include_rule);
  if (!feature || !value || !raw) return null;
  const label = exclude ? row?.exclude_label : row?.include_label;
  return stampRuleNode(raw, {
    offer_feature: feature,
    offer_value: value,
    offer_value_label: row?.top_conv_value_label || row?.value_label || row?.offer_value_label,
    label,
    direction: exclude ? 'under' : 'over',
  });
}

function normalizeSeedNode(rule) {
  if (rule?.kind === 'group') return { ...rule, children: rule.children || [] };
  return { ...emptyCondition(), ...rule };
}

/**
 * Build editor criteria from Audience Studio rules.
 * ALL/ANY applies only to includes; every exclude is ANDed in.
 */
export function criteriaFromOfferSeed(rules, matchOp) {
  const list = Array.isArray(rules) ? rules : [];
  const includes = [];
  const excludes = [];
  list.forEach((r) => {
    const node = normalizeSeedNode(r);
    if (r?.offer_direction === 'under') excludes.push(node);
    else includes.push(node);
  });
  if (!excludes.length) {
    return { kind: 'group', op: matchOp, children: includes };
  }
  if (!includes.length) {
    return { kind: 'group', op: 'AND', children: excludes };
  }
  return {
    kind: 'group',
    op: 'AND',
    children: [
      { kind: 'group', op: matchOp, children: includes },
      ...excludes,
    ],
  };
}
